import { action, computed } from 'easy-peasy';

export default {
  income: 64500,
  setIncome: action((state, income) => {
    state.income = income;
  }),

  membersAbove14: 2,
  setMembersAbove14: action((state, membersAbove14) => {
    state.membersAbove14 = membersAbove14;
  }),

  membersBelow14: 2,
  setMembersBelow14: action((state, membersBelow14) => {
    state.membersBelow14 = membersBelow14;
  }),

  weightedIncome: computed((state) =>
    Math.round(
      state.income /
        (1 + (state.membersAbove14 - 1) * 0.5 + state.membersBelow14 * 0.3)
    )
  ),
};
